import { render } from "./ListadoMovimientos.vue?vue&type=template&id=bca42274&scoped=true"
import script from "./ListadoMovimientos.vue?vue&type=script&lang=js"
export * from "./ListadoMovimientos.vue?vue&type=script&lang=js"

import "./ListadoMovimientos.vue?vue&type=style&index=0&id=bca42274&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca42274"]])

export default __exports__